import { createFileRoute, Outlet } from '@tanstack/react-router'
import { UnauthLayout as UnauthLayoutComponent } from '@/layouts'

/**
 * Unauth Layout Route (Pathless)
 *
 * Routes under this layout:
 * - /login
 * - /register
 *
 * The underscore prefix makes this route pathless - it provides layout
 * without contributing to the URL structure.
 *
 * Layout includes:
 * - Minimal centered wrapper for auth forms
 * - Branded logo in top-left corner
 * - No sidebar, no navigation chrome
 * - Responsive container optimized for auth forms
 */
export const Route = createFileRoute('/_unauth')({
  component: UnauthLayout,
})

function UnauthLayout() {
  return (
    <UnauthLayoutComponent>
      <Outlet />
    </UnauthLayoutComponent>
  )
}
